<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{
            caseParams.case?.student?.firstName +
              ' ' +
              caseParams.case?.student?.lastName
          }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"
              aria-label="Calendar"></svg-icon>
            {{
              caseParams.case?.student?.dateOfBirth ?? null | date: 'MM/dd/yyyy'
            }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"
              aria-label="Supervisor"></svg-icon>
            {{ caseParams.case?.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-16"
              aria-label="Male"></svg-icon>
            {{ caseParams.case?.student?.gender }}
          </p>
        </div>
      </div>
    </div>
    <div class="header-with-cta without-border">
      <h3 class="title s-18">Add Team Members</h3>
      <div class="cta-wrapper">
        <app-organization-search
          [defaultSelectedOrg]="orgId"
          (orgChange)="orgChange($event)">
        </app-organization-search>
        <app-search-input
          placeholder="Search members"
          [debounceTime]="1000"
          (searchChange)="handleSearch($event)">
        </app-search-input>
      </div>
    </div>
    <nz-table
      [nzData]="(usersBySchool$ | async) ?? []"
      nzTableLayout="fixed"
      [nzScroll]="{ x: '900' }"
      [nzTotal]="totalRows"
      [nzFrontPagination]="false"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="pageSize"
      (nzQueryParams)="onQueryParamsChange($event)">
      <thead>
        <tr>
          <th
            scope="col"
            nzWidth="150px"
            [nzSortFn]="true"
            [nzColumnKey]="listOfColumn[0].key">
            {{ listOfColumn[0].title }}
          </th>
          <th scope="col" nzWidth="300px" [nzColumnKey]="listOfColumn[1].key">
            {{ listOfColumn[1].title }}
          </th>
          <th scope="col" nzAlign="center" nzWidth="150px">
            {{ listOfColumn[2].title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of (usersBySchool$ | async) ?? []; let i = index">
          <td [title]="data.name">
            {{ data.name }}
          </td>
          <td [title]="data.organizationName">
            {{ data.organizationName }}
          </td>
          <td>
            <div class="action-btn-wrapper">
              <button
                nz-button
                nzType="text"
                class="primary-text-btn"
                (click)="onCreateMember(data)"
                [disabled]="existingMemberIds.has(data.id)">
                {{ existingMemberIds.has(data.id) ? 'Added' : 'Add to Team' }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>
